import { render, staticRenderFns } from "./AreaComponents.vue?vue&type=template&id=853b3834&"
import script from "./AreaComponents.vue?vue&type=script&lang=js&"
export * from "./AreaComponents.vue?vue&type=script&lang=js&"
import style0 from "./AreaComponents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports